import { useReducer } from 'react';
import { createContainer } from 'react-tracked';

const initialState = {
    showKnowledgeTestModal: false,
    isPassedKnowledgeTest: true,
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'closeKnowledgeTestModal':
            return {
                ...state,
                showKnowledgeTestModal: false,
            };
        case 'viewKnowledgeTestModal':
            return {
                ...state,
                showKnowledgeTestModal: true,
            };
        case 'setPassKnowledgeTest':
            return {
                ...state,
                isPassedKnowledgeTest: true,
            };
        case 'setFailKnowledgeTest':
            return {
                ...state,
                isPassedKnowledgeTest: false,
            };
        default:
            return state;
    }
};

const useValue = () => useReducer(reducer, initialState);

export const {
    Provider: KnowledgeTestProvider,
    useTrackedState: useKnowledgeTestState,
    useUpdate: useKnowledgeTestDispatch,
} = createContainer(useValue);
